import { render, staticRenderFns } from "./ImageFile.vue?vue&type=template&id=c8f9e398&"
import script from "./ImageFile.vue?vue&type=script&lang=js&"
export * from "./ImageFile.vue?vue&type=script&lang=js&"
import style0 from "./ImageFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImageFile.vue"
export default component.exports